var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { scrollToToc } from "../../Viewer/actions/uiActions";
import Immutable from 'immutable';
import ShowIf from "../../App/ShowIf";
import { t } from "../../I18N";
import { Icon } from "../../UI";

import "./scss/showToc.scss";

export class ShowToc extends Component {
  scrollTo(tocElement, e) {
    e.preventDefault();
    this.props.scrollToToc(tocElement.toJS());
  }

  render() {
    const toc = Immutable.fromJS(this.props.toc);

    if (!toc.size) {
      return /*#__PURE__*/(
        _jsx("div", { className: "blank-state" }, void 0, /*#__PURE__*/
        _jsx(Icon, { icon: "font" }), /*#__PURE__*/
        _jsx("h4", {}, void 0, t('System', 'No Table of Contents')), /*#__PURE__*/
        _jsx("p", {}, void 0, t('System', 'No Table of Contents description'))
        ));

    }

    return /*#__PURE__*/(
      _jsx("div", { className: "toc" }, void 0, /*#__PURE__*/
      _jsx("ul", { className: "toc-view" }, void 0,
      toc.map((tocElement, index) => /*#__PURE__*/
      _jsx("li", { className: `toc-indent-${tocElement.get('indentation')}` }, index, /*#__PURE__*/
      _jsx(ShowIf, { if: !this.props.readOnly }, void 0, /*#__PURE__*/
      _jsx("a", {
        className: "toc-view-link",
        href: "#",
        onClick: this.scrollTo.bind(this, tocElement) }, void 0,

      tocElement.get('label'), /*#__PURE__*/
      _jsx("span", { className: "page-number" }, void 0,
      tocElement.getIn(['selectionRectangles', 0]) &&
      tocElement.getIn(['selectionRectangles', 0]).get('page')
      )
      )
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: this.props.readOnly }, void 0, /*#__PURE__*/
      _jsx("span", { className: "toc-view-link" }, void 0, tocElement.get('label'))
      )
      )
      )
      )
      ));

  }
}

ShowToc.defaultProps = {
  toc: []
};







function mapDispatchToProps() {
  return { scrollToToc };
}

export default connect(null, mapDispatchToProps)(ShowToc);